module.exports = __webpack_public_path__ + "static/media/verticle-dropdown.d2674b55.svg";